const forwardDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.Shopify !== 'undefined' && window.Shopify.analytics) {
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      originalPush.apply(this, arguments);

      const newEvent = arguments[0];
      if (newEvent && newEvent.event) {
        window.Shopify.analytics.publish(newEvent.event, newEvent);
      }
    };

    window.dataLayer.forEach(function (event) {
      if (event && event.event) {
        window.Shopify.analytics.publish(event.event, event);
      }
    });
  }
};

if (window.addEventListener) {
  window.addEventListener('load', forwardDataLayer);
}
